module.exports = __webpack_public_path__ + "static/media/Screenshot4.b3af88cb.png";